import { Component, Inject, OnInit, EventEmitter } from "@angular/core";
import { HandlerModal } from "../../handler-modals";
import { DAyudasFormularioNoExperto } from "../../../../../../configuracion/dayudas-formulario-no-experto";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { DDocumento } from "@dian/api-formulario";
import { DirectionType } from "../../handler-modals";
import {
  DOperacionesMatematicasServicio,
  DTipoOperacionAritmetica,
} from "@dian-cmp/formulario";
import { DNotificacionServicio } from "@dian-cmp/notificaciones";
import { DRangosArt241ET } from "@dian-api/renta210v18";
import {
  DBasicosParametricasServicios,
  DValorPeriodico,
} from "@dian/api-basicos-parametricas";
const VAL_INDICADOR_COMPLETO = "999"; //Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = "cs_id_546";

const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;
declare var require: (filename: string) => any;

var BigNumber210 = require("bignumber.js");
const stepsList = [
  { text: "1", active: true, completed: false, tooltip: "Bienes inmuebles vendidos", listHelp: ['480'],
  },
];

const tableStructure = [
  { id: "desc", title: "Descripción" },
  { id: "valVenta", title: "Valor" },
  { id: "ubicacion", title: "Ubicación" },
];

class Form1 {
  id: number;
  desc: string; //descripcion
  valVenta: string; //valor venta
  valCompra: string; //valor compra
  anioCompra: number; //anio compra
  valDeclaradoAnioAnterior: string;
  valMejoras: string; //valor mejoras
  valAjustadoArt73: number;
  valAvaluo: string; //valor evaluo año anterior
  valImpuestoPag: string; //impuesto pagado exterior
  ubicacion: number; //venta del inmueble fue realizado en colombia
  valCostoDeclarar: string;
  impuestoCalcColombia: string;
  limitanteImpuestoExterior: string;
  selCostoDeclarar: string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: "app-renta-no-laboral-inmuebles-modal",
  templateUrl: "./renta-no-laboral-inmuebles-modal.component.html",
  styleUrls: ["./renta-no-laboral-inmuebles-modal.component.css"],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DBasicosParametricasServicios,
  ],
})
export class RentaNoLaboralInmueblesModalComponent
  extends HandlerModal
  implements OnInit
{
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstUbicaciones: ArticulosDominio[] = [];
  public lstSiNo: ArticulosDominio[] = [];
  public lstAnios: ArticulosDominio[] = [];
  public lstArticulos: ArticulosDominio[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;

  private rangosArt241ET: any;
  public UVT: string = "";
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<RentaNoLaboralInmueblesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento,
    private dBasicosParametricasServicios: DBasicosParametricasServicios
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  ngOnInit() {
    this.initializeArticulos();
    this.initializeAnios();
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.validateShowSave();
    this.rangosArt241ET = DRangosArt241ET.NUMERAL_1;
    this.obtenerValorPeriodico110();
  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.desc = "";
    this.modelForm.valCompra = "0";
    this.modelForm.anioCompra = 0;
    this.modelForm.valDeclaradoAnioAnterior = "0";
    this.modelForm.valVenta = "0";
    /*     this.modelForm.valAjustadoArt73=0; */
    this.modelForm.valMejoras = "0";
    this.modelForm.valImpuestoPag = "0";
    this.modelForm.valAvaluo = "0";
    /*    this.modelForm.valCostoDeclarar="" */ 
    this.modelForm.impuestoCalcColombia = "0";
    this.modelForm.limitanteImpuestoExterior = "0";
    this.modelForm.selCostoDeclarar = null;
    this.modelForm.ubicacion = null;
    this.modelForm.valCostoDeclarar = "0";
    this, (this.modelForm.limitanteImpuestoExterior = "0");

    this.reloadSelArticulos();
  }

  protected inicializeModelo() {
    //   if(this.model.doc.cuerpo.cs_id_482 == undefined)this.model.doc.cuerpo.cs_id_482 = [];

    if (this.model.doc.cuerpo.cc_id_901 == undefined)
      this.model.doc.cuerpo.cc_id_901 = [];
    if (this.model.doc.cuerpo.cc_id_884 == undefined)
      this.model.doc.cuerpo.cc_id_884 = [];
    if (this.model.doc.cuerpo.cc_id_879 == undefined)
      this.model.doc.cuerpo.cc_id_879 = [];
    if (this.model.doc.cuerpo.cc_id_881 == undefined)
      this.model.doc.cuerpo.cc_id_881 = [];
    if (this.model.doc.cuerpo.cc_id_880 == undefined)
      this.model.doc.cuerpo.cc_id_880 = [];
    if (this.model.doc.cuerpo.cc_id_882 == undefined)
      this.model.doc.cuerpo.cc_id_882 = [];
    if (this.model.doc.cuerpo.cc_id_902 == undefined)
      this.model.doc.cuerpo.cc_id_902 = [];
    if (this.model.doc.cuerpo.cc_id_885 == undefined)
      this.model.doc.cuerpo.cc_id_885 = [];
    if (this.model.doc.cuerpo.cc_id_883 == undefined)
      this.model.doc.cuerpo.cc_id_883 = [];

    this.model.doc.cuerpo.cc_id_678 = "0";
    this.model.doc.cuerpo.cc_id_486 = "0";
    this.model.doc.cuerpo.cc_id_482 = "0";

    if (this.model.doc.cuerpo.cc_id_903 == undefined)
      this.model.doc.cuerpo.cc_id_903 = [];
    if (this.model.doc.cuerpo.cc_id_886 == undefined)
      this.model.doc.cuerpo.cc_id_886 = [];
    if (this.model.doc.cuerpo.cc_id_887 == undefined)
      this.model.doc.cuerpo.cc_id_887 = [];
  }
  protected initializeAnios() {
    this.lstAnios[0] = { valor: 2020, nombre: "2020" };
    this.lstAnios[1] = { valor: 2021, nombre: "2021" };
    this.lstAnios[2] = { valor: 2022, nombre: "2022" };
  }

  protected initializeArticulos() {
    this.lstUbicaciones[0] = { valor: 1, nombre: "Nacional" };
    this.lstUbicaciones[1] = { valor: 2, nombre: "Extranjero" };
    this.lstSiNo[0] = { valor: 1, nombre: "Si" };
    this.lstSiNo[1] = { valor: 2, nombre: "No" };
  }

  protected reloadSelArticulos(conservarArt?: boolean) {
    //Dom 1649
    this.lstArticulos = [];

    this.lstArticulos[0] = { valor: 0, nombre: "" };
    this.lstArticulos[1] = { valor: 1, nombre: "Valor avalúo año anterior" };
    this.lstArticulos[2] = { valor: 2, nombre: "Valor Compra" };

    let i = 0;
    this.lstArticulos[i] = { valor: 0, nombre: "" };

    if (
      this.dutilidades.validacionesNumericas(
        DTipoOperacionAritmetica.MAYOR_QUE,
        this.modelForm.valAvaluo.toString(),
        "0"
      ) &&
      this.modelForm.ubicacion == 1
    ) {
      i++;
      this.lstArticulos[i] = {
        valor: 1,
        nombre: "Valor avalúo año anterior: $" + this.modelForm.valAvaluo,
      };
      this.modelForm.valImpuestoPag = "0";
    }

    if (
      this.dutilidades.validacionesNumericas(
        DTipoOperacionAritmetica.MAYOR_QUE,
        this.modelForm.valCompra.toString(),
        "0"
      )
    ) {
      i++;
      this.lstArticulos[i] = {
        valor: 2,
        nombre: "Valor Compra: $" + this.modelForm.valCompra,
      };
    }

    if(this.modelForm.ubicacion == 2){
      this.modelForm.valAvaluo = "0";
    }
  }

  public operacionCs482() {
    let suma1 = "0";
    let suma2 = "0";
    let suma3 = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma1 = this.dutilidades.ejecutarOperacion(
        DTipoOperacionAritmetica.SUMA,
        this.dataSourceBody[i].valVenta,
        suma1
      );
      suma2 = this.dutilidades.ejecutarOperacion(
        DTipoOperacionAritmetica.SUMA,
        this.dataSourceBody[i].valCostoDeclarar,
        suma2
      );
      suma3 = this.dutilidades.ejecutarOperacion(
        DTipoOperacionAritmetica.SUMA,
        this.dataSourceBody[i].limitanteImpuestoExterior,
        suma3
      );
    }
    this.model.doc.cuerpo.cs_id_482 = suma1;
    this.model.doc.cuerpo.cs_id_486 = suma2;
    this.model.doc.cuerpo.cs_id_678 = suma3;
  }

  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_901.length; i++) {
      this.modelForm.id = i;
      this.modelForm.desc = this.model.doc.cuerpo.cc_id_901[i].v;
      this.modelForm.ubicacion = this.model.doc.cuerpo.cc_id_884[i].v;
      this.modelForm.valVenta = this.model.doc.cuerpo.cc_id_879[i].v;
      this.modelForm.anioCompra = this.model.doc.cuerpo.cc_id_881[i].v;
      this.modelForm.valCompra = this.model.doc.cuerpo.cc_id_880[i].v;
      this.modelForm.valMejoras = this.model.doc.cuerpo.cc_id_882[i].v;
      this.modelForm.valAvaluo = this.model.doc.cuerpo.cc_id_902[i].v;
      this.modelForm.valImpuestoPag = this.model.doc.cuerpo.cc_id_885[i].v;
      this.modelForm.valCostoDeclarar = this.model.doc.cuerpo.cc_id_883[i].v;

      this.modelForm.valCostoDeclarar = this.model.doc.cuerpo.cc_id_883[i].v;

      this.modelForm.impuestoCalcColombia =
        this.model.doc.cuerpo.cc_id_886[i].v;
      this.modelForm.limitanteImpuestoExterior =
        this.model.doc.cuerpo.cc_id_887[i].v;
      this.modelForm.valCostoDeclarar = this.model.doc.cuerpo.cc_id_903[i].v;

      //this.modelForm.valAjustadoArt73=this.model.doc.cuerpo.cc_id_880[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_901[this.modelForm.id].v = this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_884[this.modelForm.id].v =
      this.modelForm.ubicacion;
    this.model.doc.cuerpo.cc_id_879[this.modelForm.id].v =
      this.modelForm.valVenta;
    this.model.doc.cuerpo.cc_id_881[this.modelForm.id].v =
      this.modelForm.anioCompra;
    this.model.doc.cuerpo.cc_id_880[this.modelForm.id].v =
      this.modelForm.valCompra;
    this.model.doc.cuerpo.cc_id_882[this.modelForm.id].v =
      this.modelForm.valMejoras;
    this.model.doc.cuerpo.cc_id_902[this.modelForm.id].v =
      this.modelForm.valAvaluo;
    this.model.doc.cuerpo.cc_id_885[this.modelForm.id].v =
      this.modelForm.valImpuestoPag;
    this.model.doc.cuerpo.cc_id_883[this.modelForm.id].v =
      this.modelForm.selCostoDeclarar;

    this.model.doc.cuerpo.cc_id_903[this.modelForm.id].v =
      this.modelForm.valCostoDeclarar;
    this.model.doc.cuerpo.cc_id_886[this.modelForm.id].v =
      this.modelForm.impuestoCalcColombia;
    this.model.doc.cuerpo.cc_id_887[this.modelForm.id].v =
      this.modelForm.limitanteImpuestoExterior;

    // this.model.doc.cuerpo.cc_id_712[this.modelForm.id].v=this.dutilidades.deshacerFormatoMoneda(this.modelForm.valCostoDeclarar);
  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_901.push({ it: i, v: this.modelForm.desc });
    this.model.doc.cuerpo.cc_id_884.push({
      it: i,
      v: this.modelForm.ubicacion.toString(),
    });
    this.model.doc.cuerpo.cc_id_879.push({
      it: i,
      v: this.modelForm.valVenta.toString(),
    });
    this.model.doc.cuerpo.cc_id_881.push({
      it: i,
      v: this.modelForm.anioCompra.toString(),
    });
    this.model.doc.cuerpo.cc_id_880.push({
      it: i,
      v: this.modelForm.valCompra.toString(),
    });
    this.model.doc.cuerpo.cc_id_882.push({
      it: i,
      v: this.modelForm.valMejoras.toString(),
    });
    this.model.doc.cuerpo.cc_id_902.push({
      it: i,
      v: this.modelForm.valAvaluo.toString(),
    });
    this.model.doc.cuerpo.cc_id_885.push({
      it: i,
      v: this.modelForm.valImpuestoPag.toString(),
    });
    this.model.doc.cuerpo.cc_id_883.push({
      it: i,
      v: this.modelForm.selCostoDeclarar.toString(),
    });

    this.model.doc.cuerpo.cc_id_903.push({
      it: i,
      v: this.modelForm.valCostoDeclarar.toString(),
    });
    this.model.doc.cuerpo.cc_id_886.push({
      it: i,
      v: this.modelForm.impuestoCalcColombia.toString(),
    });
    this.model.doc.cuerpo.cc_id_887.push({
      it: i,
      v: this.modelForm.limitanteImpuestoExterior.toString(),
    });

    //this.model.doc.cuerpo.cc_id_712.push({it: i, v:this.dutilidades.deshacerFormatoMoneda(this.modelForm.valCostoDeclarar)});
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_901.splice(index, 1);
    this.model.doc.cuerpo.cc_id_884.splice(index, 1);
    this.model.doc.cuerpo.cc_id_879.splice(index, 1);
    this.model.doc.cuerpo.cc_id_881.splice(index, 1);
    this.model.doc.cuerpo.cc_id_880.splice(index, 1);
    this.model.doc.cuerpo.cc_id_882.splice(index, 1);
    this.model.doc.cuerpo.cc_id_902.splice(index, 1);
    this.model.doc.cuerpo.cc_id_885.splice(index, 1);
    this.model.doc.cuerpo.cc_id_883.splice(index, 1);

    this.model.doc.cuerpo.cc_id_903.splice(index, 1);
    this.model.doc.cuerpo.cc_id_886.splice(index, 1);
    this.model.doc.cuerpo.cc_id_887.splice(index, 1);

    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_901.length; i++) {
      this.model.doc.cuerpo.cc_id_901[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_884[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_879[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_881[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_880[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_882[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_902[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_885[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_883[i].it = i + 1;

      this.model.doc.cuerpo.cc_id_903[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_886[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_887[i].it = i + 1;
    }
  }

  public validateFormCompleted(): boolean {
    return (
      this.modelForm.desc == undefined ||
      this.modelForm.desc == "" ||
      this.modelForm.valCompra == undefined ||
      this.modelForm.valCompra == "0" ||
      this.modelForm.valVenta == undefined ||
      this.modelForm.valVenta == "0" ||
      this.modelForm.anioCompra == undefined ||
      this.modelForm.anioCompra == 0 ||
      this.modelForm.valAvaluo == undefined ||
      this.modelForm.valAvaluo == "" ||
      this.modelForm.ubicacion == undefined ||
      this.modelForm.ubicacion == 0 ||
      this.modelForm.valMejoras == undefined ||
      this.modelForm.valMejoras == "" ||
      //this.modelForm.valImpuestoPag == undefined ||
/*       this.modelForm.valImpuestoPag == "0" || */
      this.modelForm.selCostoDeclarar == undefined ||
      ( this.modelForm.ubicacion == 2  && this.modelForm.valImpuestoPag == "0"  )
    );
  }

  public redondearFormData() {
  /*   this.modelForm.valVenta = Number(
      this.dutilidades.redondearValorMoneda(this.modelForm.valVenta.toString(),true)
    ); */

    this.modelForm.valVenta=this.dutilidades.redondearValorMoneda(this.modelForm.valVenta.toString(),true);
    this.modelForm.valCompra=this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(),true);
    this.modelForm.valMejoras=this.dutilidades.redondearValorMoneda(this.modelForm.valMejoras.toString(),true);
    this.modelForm.valImpuestoPag=this.dutilidades.redondearValorMoneda(this.modelForm.valImpuestoPag.toString(),true);
    this.modelForm.valAvaluo=this.dutilidades.redondearValorMoneda(this.modelForm.valAvaluo.toString(),true);
    this.modelForm.valDeclaradoAnioAnterior=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(),true);


  }

  public calcularValoresForm() {
    console.log(this.modelForm);
    this.redondearFormData();

    //calculos valCostoDeclarar
    const valSelCostoDeclarar =
      this.modelForm.selCostoDeclarar == "1"
        ? this.modelForm.valAvaluo
        : this.modelForm.selCostoDeclarar == "2"
        ? this.modelForm.valCompra
        : 0;
     this.modelForm.valCostoDeclarar =
      this.dutilidades.ejecutarOperacion(
        DTipoOperacionAritmetica.SUMA,
        valSelCostoDeclarar.toString(),
        this.modelForm.valMejoras.toString(),
        true
      );

      //calculos impuestoCalcColombia
   const cas879 = this.modelForm.valVenta.toString();
   const cas903 = this.modelForm.valCostoDeclarar;

     let base = this.dutilidades.ejecutarOperacion(
       DTipoOperacionAritmetica.RESTA,
       cas879,
       cas903
     );
     base = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,base,"0")?"0":base;
     
     const valorEnUvt = this.convertirPesosUvt(base);
     let resultado = this.aplicarTablaArt241ET(
       valorEnUvt,
       this.rangosArt241ET
     );
     resultado = this.dutilidades.redondearValorMoneda(resultado, true);

     this.modelForm.impuestoCalcColombia = resultado;

     //calculos limitante
     if(this.dutilidades.validacionesNumericas(
      DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,
      this.modelForm.valImpuestoPag.toString(),
      this.modelForm.impuestoCalcColombia
    )){
      this.modelForm.limitanteImpuestoExterior = this.modelForm.valImpuestoPag;
     }else{
      this.modelForm.limitanteImpuestoExterior = this.modelForm.impuestoCalcColombia;
     }

     this.reloadSelArticulos();
  }

  saveItem(): void {
     if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError(
        "Debe diligenciar todos los campos para agregar un nuevo registro"
      );
      return;
    } else {
      this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        this.editModeloDesdeForm();
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs482();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.model);
    } 
  }

  eventTable($event: string): void {
    if ($event === "add") this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === "edit") this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === "delete") this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs482();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {
      //editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {
      //borrando
      this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }

  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {}

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {}

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS: number): boolean {
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive() {}

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance() {
    let casIndicadorAvance = this.obtenerCasIndicadorAvance();
    if (this.indexStepper > Number(casIndicadorAvance)) {
      let indexS = this.indexStepper + 1;
      while (!this.validateStepHabilitado(indexS)) {
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = indexS.toString();
    }
    if (this.indexStepper == this.stepsList.length - 1) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?: boolean) {
    let casIndicadorAvance = this.obtenerCasIndicadorAvance();
    if (forceUpdateStepper) {
      this.changeStep(index);
      this.updateIndicadorAvance();
    } else if (this.validateStepHabilitado(index)) {
      let indexCalc = index - 1;
      if (indexCalc <= Number(casIndicadorAvance)) {
        this.changeStep(index);
        this.updateIndicadorAvance();
      } else {
        console.log(
          "Avance no permitido: casIndicadorAvance=" +
            casIndicadorAvance +
            ", index-1=" +
            indexCalc
        );
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave() {
    if (
      this.indexStepper == this.stepsList.length - 1 ||
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO
    ) {
      this.showSave = true;
    }
  }
  public closeModal() {
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar() {
    this.saveModel.emit(true);
    if (this.indexStepper == this.stepsList.length - 1) {
      this.closeModal();
    }
  }

  changeCs884() {
    console.log(this.modelForm);
  }

  operaciones(casilla: number) {
    this.reloadSelArticulos();
  }

  private aplicarTablaArt241ET(baseGravable, rangos) {
    let desde: boolean = false;

    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(
        DTipoOperacionAritmetica.MAYOR_QUE,
        baseGravable,
        rangos[i].desde
      );

      if (i + 1 < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(
          DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,
          baseGravable,
          rangos[i + 1].desde
        );
      } else {
        hasta = true;
      }

      if (desde && hasta) {
        const resultadoResta = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.RESTA,
          baseGravable,
          rangos[i].desde
        );

        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.MULTIPLICACION,
          resultadoResta,
          rangos[i].tarifa
        );

        const punto = resultadoMultiplicacion.indexOf(".");

        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(
            0,
            punto + 3
          );
        }

        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.SUMA,
          resultadoMultiplicacion,
          rangos[i].impuesto
        );

        const resultadoOperacion = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.MULTIPLICACION,
          resultadoSuma2,
          this.UVT
        );

        return resultadoOperacion;
      }
    }

    return "0";
  }

  //UVT

  private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios
      .obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION)
      .subscribe(
        (data) => this.setObjectFromResponse(data),

        (error) => console.log(error)
      );
  }

  private setObjectFromResponse(data: any): void {
    let model = <DValorPeriodico>data;
    this.UVT = String(model.valor);
  }

  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);

    let valorOperacion = new BigNumber210(valorPesos);

    valorOperacion = valorOperacion.div(this.UVT);

    valorOperacion = valorOperacion.toFormat();

    const punto = valorOperacion.indexOf(".") + 1;

    if (punto > 0 && valorOperacion.length - punto > 2)
      valorOperacion = valorOperacion.slice(0, -1);

    return String(valorOperacion);
  }

  protected operarCamposCuerpo(
    operacion: DTipoOperacionAritmetica,
    modelo: DDocumento,
    campos: Array<string>,
    formatear: boolean
  ): string {
    let valores = [];

    for (let i in campos) {
      if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
        let valor = this.dutilidades.redondearValorMoneda(
          modelo.doc.cuerpo[campos[i]]
        );

        valores.push(valor);

        //valores.push(modelo.doc.cuerpo[campos[i]]);
      } else {
        valores.push("0");
      }
    }

    return this.dutilidades.ejecutarOperacionMultipleValores(
      valores,
      operacion,
      formatear
    );
  }

  operacionCs886() {
  /*   this.calcularValoresForm();
    const cas879 = this.modelForm.valVenta.toString();
    const cas903 = this.modelForm.valCostoDeclarar;

      const base = this.dutilidades.ejecutarOperacion(
        DTipoOperacionAritmetica.RESTA,
        cas879,
        cas903
      );
      const valorEnUvt = this.convertirPesosUvt(base);
      let resultado = this.aplicarTablaArt241ET(
        valorEnUvt,
        this.rangosArt241ET
      );
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);

      // const valor = Buscar(base,Tabla art_241);

      this.modelForm.impuestoCalcColombia = resultado; */

   /*    this.operacionCs313(); */
    }
  
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-inmuebles-modal/renta-no-laboral-inmuebles-modal.component.ts